import { BaseAPI } from './BaseAPI.js'
import { Queue } from '../types/index.js'

export default class QueuesAPI extends BaseAPI<Queue> {
  override get resource(): string {
    return '/queues'
  }

  async copyFlow(id: string | number, targetQueueIds: number[], flowType: 'inboundFlow' | 'outboundFlow'): Promise<any> {
    const result = await this._client.post(`${this.resource}/${id}/copy-flow`, {
      targetQueueIds,
      flowType,
    })
    return result.data
  }
}
